var _path, _rect, _rect2, _rect3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.751,7.995h8.988c3.541,0,6.411,2.87,6.411,6.411h0c0,3.541-2.87,6.411-6.411,6.411H11.26c-3.541,0-6.411,2.87-6.411,6.411v1.134c0,3.541,2.87,6.411,6.411,6.411h13.877"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.414,
    y: 2.893,
    width: 12.338,
    height: 10.204
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.175,
    y: 30.441,
    width: 7.4,
    height: 8.666
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.575,
    y: 31.804,
    width: 4.576,
    height: 5.745
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.414,
    y1: 5.639,
    x2: 4.849,
    y2: 5.639
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.414,
    y1: 10.351,
    x2: 4.849,
    y2: 10.351
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAccessories);
export default __webpack_public_path__ + "static/media/indoor-accessories.4fe29ab108009de4541b11bc824943a9.svg";
export { ForwardRef as ReactComponent };